import Reflux from 'reflux';

const AlertConditionsActions = Reflux.createActions({
  available: { asyncResult: true },
  delete: { asyncResult: true },
  list: { asyncResult: true },
  listAll: { asyncResult: true },
  save: { asyncResult: true },
  update: { asyncResult: true },
  get: { asyncResult: true },
  test: { asyncResult: true },
});

export default AlertConditionsActions;



// WEBPACK FOOTER //
// ../graylog2-server/graylog2-web-interface/src/actions/alertconditions/AlertConditionsActions.jsx